import { useUpdateServiceBooking, useBusinesses } from "@/hooks/api-hooks";
import { Loader, Select } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Business, ServiceBooking } from "@turizi/shared";
import { SERVICE_CATEGORIES } from "@turizi/shared";

interface CoordinatorSelectorProps {
    booking: ServiceBooking;
    size?: 'xs' | 'sm' | 'md' | 'lg';
    editable?: boolean;
}

export default function CoordinatorSelector({
    booking,
    size = 'sm',
    editable = true
}: CoordinatorSelectorProps) {
    const { t } = useTranslation();
    const {
        mutate: updateMutation,
        isPending: saving
    } = useUpdateServiceBooking();
    const {
        data: businessesResponse,
        isLoading: loadingBusinesses
    } = useBusinesses(
        {
            category: SERVICE_CATEGORIES.coordinator
        }
    );
    const businesses = businessesResponse?.data || [];

    const save = (coordinatorId: number | null) => {
        if (!booking?.id) return;
        updateMutation({
            id: booking.id,
            coordinator_id: coordinatorId,
        });
    };

    if (!booking) {
        return null;
    }

    if (!editable) {
        return (
            <div className="font-bold text-gray-600 bg-gray-50 rounded-md px-2 py-1 border border-gray-100 text-xxs">
                {booking.coordinator?.name || '--'}
            </div>
        );
    }

    const loading = saving || loadingBusinesses;

    return (
        <div>
            <Select
                variant="filled"
                searchable
                size={size}
                placeholder={t('coordinator')}
                value={booking.coordinator_id?.toString()}
                data={businesses.map((business: Business) => ({
                    value: business.id.toString(),
                    label: business.name
                }))}
                onChange={(value) => save(value ? Number(value) : null)}
                disabled={loading}
                rightSection={loading ? <Loader size="xs" color="black" /> : null}
                comboboxProps={{ keepMounted: false }}
                allowDeselect
            />
        </div>
    );
}
